import { NO_PERIOD_PERIOD_NAME } from '@app/src/components/CreateNewRequestModal/PeriodSelector/PeriodSelector'

type PeriodType = 'Y' | 'H' | 'Q' | 'M'

interface PeriodInfo {
  year: number
  type: PeriodType
  value: number
}

const parsePeriod = (s: string): PeriodInfo => {
  let type: PeriodType = 'Y'
  let value = 1
  let year: number

  if (s.includes(' ')) {
    const parts = s.split(' ')
    year = parseInt(parts[1], 10)
    type = parts[0][0] as PeriodType
    value = parseInt(parts[0].substring(1), 10)
  } else if (s.includes('-')) {
    const parts = s.split('-')
    year = parseInt(parts[0], 10)
    type = 'M'
    value = parseInt(parts[1], 10)
  } else {
    year = parseInt(s, 10)
  }

  return { year, type, value }
}

const periodInfoToString = (periodInfo: PeriodInfo): string => {
  if (periodInfo.type === 'Y') return `${periodInfo.year}`
  else if (periodInfo.type === 'M') return `${periodInfo.year}-${periodInfo.value}`
  return `${periodInfo.type}${periodInfo.value} ${periodInfo.year}`
}

const periodsInYear: Record<PeriodType, number> = {
  Y: 1, // Year
  H: 2, // Half-Year
  Q: 4, // Quarter
  M: 12, // Month
}

const getPreviousPeriodInfo = (periodInfo: PeriodInfo): PeriodInfo => {
  if (periodInfo.value === 1) {
    const totalPeriodsInYear = periodsInYear[periodInfo.type]
    return { type: periodInfo.type, year: periodInfo.year - 1, value: totalPeriodsInYear }
  }
  return { ...periodInfo, value: periodInfo.value - 1 }
}

export const getPreviousPeriod = (period: string | number): string => {
  if (period === NO_PERIOD_PERIOD_NAME) throw new Error('Cannot get previous period of NO_PERIOD')
  const periodInfo = parsePeriod(String(period))
  const previousPeriodInfo = getPreviousPeriodInfo(periodInfo)
  return periodInfoToString(previousPeriodInfo)
}

export const comparePeriods = (a: string | number, b: string | number): number => {
  if (a === NO_PERIOD_PERIOD_NAME || b === NO_PERIOD_PERIOD_NAME) return a === NO_PERIOD_PERIOD_NAME ? -1 : 1
  const aInfo = parsePeriod(String(a))
  const bInfo = parsePeriod(String(b))

  // Compare by year
  if (aInfo.year !== bInfo.year) {
    return aInfo.year - bInfo.year
  }

  // If the same year, compare by period type weight
  if (periodsInYear[aInfo.type] !== periodsInYear[bInfo.type]) {
    return periodsInYear[aInfo.type] - periodsInYear[bInfo.type]
  }

  // If same year and same type weight, compare by value
  return aInfo.value - bInfo.value
}
